'use client';

import { useEffect } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import NavigationBar from "./Navbar";
import Footer from "./Footer";
import { useAtom, useSetAtom } from 'jotai'
import * as atoms from '@/config/store/globalStore'
import { COOKIE_ITEMS, getCookieItem } from '@/utils/cookieControl'
import { API_ENDPOINT } from '@/config/endpoint/endpoint'
import mixpanel from 'mixpanel-browser';
import { SupportedLanguage } from '@/config/store/globalStore';
import { mixpanelSetUser } from '@/utils/mixpanel';
// import Maintanance from '@/components/Maintanance';
// import MobileMenu from './MobileMenu';

// Remove dynamic import and use regular import at the top

mixpanel.init('124f0686fc83c497f94548abbffafc64', {
  debug: true, 
  track_pageview: true,
  persistence: 'localStorage'
});

interface DefaultLayoutProps {
  children: React.ReactNode;
  initialLanguage?: SupportedLanguage;
}

export default function DefaultLayout({ children, initialLanguage }: DefaultLayoutProps) {
  const [ userInfo, setUserinfo ] = useAtom(atoms.userInfo);
  const setSignedIn = useSetAtom(atoms.signIn);
  const setLanguage = useSetAtom(atoms.currentLanguage);

  useEffect(() => {
    checkUserInfo()
    
    // 서버에서 전달받은 언어가 있으면 즉시 설정
    if (initialLanguage) {
      setLanguage(initialLanguage);
    }
  }, [initialLanguage, setLanguage]);
  
  async function checkUserInfo() {
    const signIn = getCookieItem(COOKIE_ITEMS.signIn)

    try {
      if (signIn === 'true') {
        const user = await API_ENDPOINT.account.checkUser();
        const { user_id, name, tier, credit } = user
        setSignedIn(true)
        setUserinfo({ user_id, name, tier, credit })
        mixpanelSetUser(userInfo)
      } else {
        setSignedIn(false)
      }
    } catch {
      setSignedIn(false)
      await API_ENDPOINT.account.logout()
    }
  }


  // 에러페이지
  // return (
//     <MantineProvider theme={theme}>
//       <ModalsProvider>
//         <Maintanance/>
//       </ModalsProvider>
//     </MantineProvider>
  // )


  return (
    <>
      <Toaster
        toastOptions={{ duration: 2000 }}
        containerStyle={{ fontSize: 14 }}
      />
      <NavigationBar initialLanguage={initialLanguage}/>
      {children}
      <Footer/>
      {/* <MobileMenu/> */}
    </>
  );
}